import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { authenticationSlice } from '@cp/shared/api/core';
import { IAuthService } from '@cp/shared/auth';

export const useAuthService = (): IAuthService => {
  const dispatch = useDispatch();
  return useMemo(
    () => ({
      authorize: (token) => dispatch(authenticationSlice.actions.setToken(token)),
    }),
    [dispatch],
  );
};
